import { render, staticRenderFns } from "./BooleanAttributeRenderer.vue?vue&type=template&id=50016672"
import script from "./BooleanAttributeRenderer.vue?vue&type=script&lang=js"
export * from "./BooleanAttributeRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports